module.exports = __webpack_public_path__ + "img/shop2.0895f0c6.png";